











const subItems = [
  {
    label: '首页',
    path: '/search',
    subItems: [
      {
        path: '/search/party',
        label: '第三方账号管理'
      },
      {
        path: '/search/users',
        label: '账号安全'
      },
      {
        path: '/search/detail',
        label: '试卷详情'
      }
    ]
  }
]
import { Component, Vue, Prop, Provide } from 'vue-property-decorator'
let menusArr = []
@Component
export default class Breadcrumb extends Vue {
  public get options() {
    // return location.pathname
    return this.getPathInfo(subItems)
  }
  public getPathInfo(subs: any) {
    let sub = subs.filter((item) => {
      return location.pathname.includes(item.path)
    })
    if (sub.length > 0) {
      menusArr = menusArr.concat(sub)
      if (sub[0].subItems) {
        this.getPathInfo(sub[0].subItems)
      }
    }

    return menusArr
  }
}
